<template>
  <div>
    <main-jumbotron />
    <div v-if="typeof listing !== 'undefined'">
      <Loader v-if="loading" :text="`Chapter ${$route.params.two} - ${listing.desc}`"/>
      <div class="two-container" v-else>
        <b-container>
          <b-breadcrumb class="p-0 bg-white">
            <b-breadcrumb-item :to="{name: 'home'}">Home</b-breadcrumb-item>
            <b-breadcrumb-item active><b>Chapter {{ $route.params.two }}</b></b-breadcrumb-item>
          </b-breadcrumb>

          <h5 class="heading">HSN Code for <b>Chapter {{ $route.params.two }}</b> - {{ listing.desc }}</h5>
          <b-card class="shadow-sm mb-4" body-class="two-body" v-for="(item, i) in listing.codes" :key="i">
            <b-card-text text-tag="div" class="two-text">
              <div>
                <h5 class="lato font-weight-bold">{{ Object.keys(item)[0] }}</h5>
                <p class="mb-0 pr-3">{{ item[Object.keys(item)[0]] }}</p>
              </div>
              <div>
                <b-btn class="view-all" :to="{name: 'hsCode', params: {id: Object.keys(item)[0] }}" @click.native="maClick('View All', Object.keys(item)[0])">View All</b-btn>
              </div>
            </b-card-text>
            <template slot="footer">
              <frequently-used :code="Object.keys(item)[0]" :key="$route.params.two" />
            </template>
          </b-card>
        </b-container>
      </div>
    </div>
    <not-found v-else/>
  </div>
</template>

<script>
import MainJumbotron from '@/components/MainJumbotron'
import FrequentlyUsed from '@/components/FrequentlyUsed/'
import Loader from '@/components/Loader/'
import NotFound from '@/components/NotFound/'
import ma from '../../mixins/ma'
import LoaderMixin from '@/mixins/loader/'
export default {
  data () {
    return {
      two: this.$store.state.twos
    }
  },
  metaInfo () {
    return {
      title: this.$route.params.two,
      titleTemplate: `HSN Codes for Chapter %s - ${this.listing.desc}`,
      meta: [{
        vmid: 'description',
        name: 'description',
        content: `Find the list of all HSN Codes and their GST Rates at 4 digit, 6 digit and 8 digit levels for Chapter ${this.$route.params.two} ${this.listing.desc}`
      }]
    }
  },
  computed: {
    listing () {
      return this.two[this.$route.params.two]
    }
  },
  components: {
    FrequentlyUsed,
    MainJumbotron,
    NotFound,
    Loader
  },
  mixins: [LoaderMixin, ma]
}
</script>

<style lang="scss" scoped>

.two-container {
  padding: 2rem 0 4rem;
  .heading {
    margin: 2rem 0;
    line-height: 2rem;
  }
  .breadcrumb-item {
    &.active, a {
      color: $secondary
    }
  }
  .view-all {
    white-space: nowrap;
    border-radius: 5px;
  }
  .two-body {
    .two-text {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
  .card {
    border-color: $light-blue;
    .card-footer {
      padding: 0;
      background-color: white;
    }
  }
}
</style>
